//include 9
jQuery(function(){

    var mapFunctions = {
        mapObject() {
            var airBnB = null;
            if (typeof ppcartoAirbnb != "undefined" && !!ppcartoAirbnb && !!ppcartoAirbnb.$refs && !!ppcartoAirbnb.$refs.airbnb) {
                airBnB = ppcartoAirbnb.$refs.airbnb;
            } else if (typeof ppcartoStatic != "undefined" && !!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static) {
                airBnB = ppcartoStatic.$refs.static;
            }
            return airBnB;
        },
        getMapType() {
            if (typeof ppcartoAirbnb != "undefined" && !!ppcartoAirbnb && !!ppcartoAirbnb.$refs && !!ppcartoAirbnb.$refs.airbnb) {
                return "airbnb";
            } else if (typeof ppcartoStatic != "undefined" && !!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static) {
                return "static";
            }
            return "undefined";
        },
        removeBBox() {
            var mapObject = mapFunctions.mapObject();
            if (!!mapObject.filter && !!mapObject.filter.bbox) {
                delete mapObject.filter.bbox;
            }
        },
        getBBox() {
            var mapObject = mapFunctions.mapObject();
            if (!mapObject || !mapObject.bbox)
                return null;
            return mapObject.bbox();
        },
        reloadData() {
            var mapObject = mapFunctions.mapObject();
            if (!!mapObject) {
                mapObject.init = true;
                //mapObject.getData();
            }
        },
        clearRegionFromAirBnB() {
            var airBnB = mapFunctions.mapObject();
            if (!airBnB || !airBnB.clearRegion)
                return;
            airBnB.clearRegion();
        },
        regionToAirBnB(id, type) {
            if (!id)
                return;
            type = type || 'region';
            var airBnB = mapFunctions.mapObject();

            if (!airBnB)
                return;
            airBnB.setRegion({
                type: type,
                id: window.pixelpoint.utilities.getMapRegion(id)//id
            });
        },
        setFilters(type, filters, changeMapSection, removeBBox) {
            changeMapSection = changeMapSection || false;
            removeBBox = removeBBox || false;
            type = type || 'poi';

            var manuallyReloadData = false;
            var airbnb = mapFunctions.mapObject();

            if (!airbnb)
                return;

            airbnb.type = type;
            airbnb.filter = filters;

            if (!!removeBBox) {
                mapFunctions.removeBBox();
                manuallyReloadData = true;
            }
            if (!!changeMapSection) {
                manuallyReloadData = true;
            }
            if (!!manuallyReloadData && false)
                mapFunctions.reloadData();
        },
        setOffset(offset) {
            offset = offset || 0;
            var airBnB = mapFunctions.mapObject();
            if (!airBnB)
                return;
            airBnB.offset = offset;
        },
        changeBBox(zoom, coordinates, callback) {
            var airBnB = mapFunctions.mapObject();
            if (!airBnB)
                return;
            var viewArguments = {};
            if (!!zoom && zoom > 0) {
                viewArguments.zoom = zoom;
            }
            if (!!coordinates && coordinates.length >= 2 && coordinates[0] > 0 && coordinates[1] > 0) {
                viewArguments.coordinates = coordinates;
            }
            if (!viewArguments)
                return;

            var isAirBnB = (mapFunctions.getMapType() == "airbnb");

            airBnB.$once("moveend", function () {
                if (!!callback) {
                    callback();
                }
            });

            if (!!isAirBnB) {
                airBnB.$nextTick(function () {
                    airBnB.init = false;
                    airBnB.changeView(viewArguments);
                });
            } else {
                setTimeout(function () {
                    airBnB.$nextTick(function () {
                        airBnB.init = false;
                        airBnB.changeView(viewArguments);
                    });
                }, 100);
            }
        },
        onMoveEnd(callback) {
            var map = mapFunctions.mapObject();
            if (!!map && !!callback) {
                map.$on("moveend", function (data) {
                    callback(data);
                });
            }
        },
        onHighlightOver(callback) {
            var map = mapFunctions.mapObject();
            if (!!map && !!callback) {
                map.$on("highlightover", function (data) {
                    callback(data);
                });
            }
        },
        onHighlightOut(callback) {
            var map = mapFunctions.mapObject();
            if (!!map && !!callback) {
                map.$on("highlightout", function (data) {
                    callback(data);
                });
            }
        },
        focusItem(id) {
            var map = mapFunctions.mapObject();
            if (!!map) {
                map.focusItem(id);
            }
        },
        watchOnChange(callback) {
            var map = mapFunctions.mapObject();
            if (!map || !callback)
                return null;
            return map.$watch('geojson.features', function () {
                callback(map.features);
            });
        },
        getFeatures(){
             var map = mapFunctions.mapObject();
            if (!map)
                return null;
            if(!!map.geojson && !!map.geojson.features && map.geojson.features.length > 0)
                return map.geojson.features;
            return map.features;
        },
        clearLayers() {
            var map = mapFunctions.mapObject();
            if (!map || !map.config || !map.config.layers)
                return false;
            map.config.layers = [];
            return true;
        },
        addToLayer(type, id, limit) {
            var map = mapFunctions.mapObject();
            limit = limit || 25;
            if (!map || !map.config || !map.config)
                return false;
            if(!map.config.layers){
                map.config.layers = [];
            }
            var added = false;
            for(var i in map.config.layers){
                if(map.config.layers[i].type == type)
                {
                    if(!map.config.layers[i].filter)
                        map.config.layers[i].filter = {limit:limit,external_id:[]};
                    if(!map.config.layers[i].filter.external_id){
                        map.config.layers[i].filter.external_id = [];
                    }
                    map.config.layers[i].filter.external_id.push(id);
                    added = true;
                    break;
                }  
            }
            if(!added){
                map.config.layers.push({
                    type:type,
                    filter:{
                      limit:limit,
                      external_id:[id]  
                    }
                });
            }
            return true;
        }
    };

    window.pixelpoint.airBnB = mapFunctions;

});